import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource/archivo-black";
import "./index.css";

// After a new deploy, old page files are replaced. A tab still open on the
// previous version then fails to load a page. Reload once to pick up the new
// version instead of showing a blank screen.
const RELOAD_KEY = "chunk-reload-at";
const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 10000) return; // avoid reload loops
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  reloadOnce();
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = String((e.reason as Error)?.message ?? e.reason ?? "");
  if (/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg)) {
    reloadOnce();
  }
});

// Static page content is readable before JS; mount normally rather than
// hydrating snapshots that contain scroll animation and browser-only state.
const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);
